module.exports = __webpack_public_path__ + "static/media/Firebase.3ced6c61.svg";